import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Clock, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function TapReturn() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ result: "loading" });
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const orderId = params.get("order_id");
    const tapId = params.get("tap_id") || params.get("charge_id");
    const type = params.get("type");
    if (type === "subscription") {
      if (!tapId) { setState({ result: "error" }); return; }
      api.post("/payments/tap/subscription/verify", { tap_id: tapId })
        .then(({ data }) => setState({ result: data.result, sub: true }))
        .catch(() => setState({ result: "error" }));
      return;
    }
    if (!orderId || !tapId) { setState({ result: "error" }); return; }
    api.post("/payments/tap/verify", { order_id: orderId, tap_id: tapId })
      .then(({ data }) => setState({ result: data.result, order: orderId }))
      .catch(() => setState({ result: "error" }));
  }, [params]);

  const MAP = {
    loading: { icon: Loader2, spin: true, color: "#F59E0B", title: "جارٍ التحقق من عملية الدفع...", sub: "لحظات من فضلك" },
    success: { icon: CheckCircle2, color: "#10B981", title: "تم الدفع بنجاح", sub: "تم استلام دفعتك وتأكيد طلبك بنجاح." },
    failed: { icon: XCircle, color: "#EF4444", title: "فشلت عملية الدفع", sub: "لم تكتمل عملية الدفع. يمكنك المحاولة مجددًا من طلباتك." },
    cancelled: { icon: XCircle, color: "#EF4444", title: "تم إلغاء الدفع", sub: "تم إلغاء عملية الدفع. طلبك ما زال محفوظًا." },
    pending: { icon: Clock, color: "#F59E0B", title: "الدفع قيد المعالجة", sub: "لم تتأكد العملية بعد. تابع حالة طلبك من حسابك." },
    error: { icon: XCircle, color: "#EF4444", title: "تعذّر التحقق من الدفع", sub: "يرجى مراجعة طلباتك أو التواصل مع دعم المنصة." },
  };
  const v = MAP[state.result] || MAP.error;
  const Icon = v.icon;

  return (
    <div className="mx-auto max-w-md px-4 py-20 text-center" data-testid="tap-return-page">
      <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl mb-5" style={{ backgroundColor: `${v.color}22`, color: v.color }}>
        <Icon size={40} className={v.spin ? "animate-spin" : ""} />
      </span>
      <h1 data-testid="tap-result" data-result={state.result} className="font-head text-2xl font-black text-white mb-2">{v.title}</h1>
      <p className="text-[var(--text-muted)] mb-8">{v.sub}</p>
      {state.result !== "loading" && (
        <div className="flex gap-3 justify-center">
          {state.sub
            ? <Link to="/seller" data-testid="go-orders" className="btn-amber">العودة للوحة التشليح</Link>
            : <><Link to="/orders" data-testid="go-orders" className="btn-amber">عرض طلباتي</Link>
                <Link to="/search" className="rounded-xl border border-[var(--border-c)] px-5 py-3 font-bold text-white hover:border-[var(--amber)]">متابعة التسوق</Link></>}
        </div>
      )}
    </div>
  );
}
